import React, { useState, useEffect } from 'react';
import ChatMessage from './components/ChatMessage';
import ChatInput from './components/ChatInput';
import Login from './components/Login';
import Signup from './components/Signup';
import useChat from './hooks/useChat';
import { VERSION } from './config/version';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [showSignup, setShowSignup] = useState(false);
  const { messages, sendMessage, isLoading, resetChat, messagesEndRef, clearMessages, loadHistory } = useChat(user?.username);

  // Check for existing session on app load
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    const savedUser = localStorage.getItem('user');
    
    console.log('App.js useEffect - token:', token ? 'exists' : 'none');
    console.log('App.js useEffect - savedUser:', savedUser ? 'exists' : 'none');
    
    if (token && savedUser) {
      try {
        const userData = JSON.parse(savedUser);
        console.log('App.js useEffect - parsed user:', userData);
        setUser(userData);
        setIsAuthenticated(true);
      } catch (error) {
        console.log('App.js useEffect - error parsing user data:', error);
        // Invalid stored data, clear it
        localStorage.removeItem('authToken');
        localStorage.removeItem('user');
      }
    } else {
      console.log('App.js useEffect - no cached auth, showing login');
    }
  }, []);

  const handleLogin = (userData, token) => {
    setUser(userData);
    setIsAuthenticated(true);
    localStorage.setItem('authToken', token);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const handleSignup = (userData, token) => {
    setUser(userData);
    setIsAuthenticated(true);
    localStorage.setItem('authToken', token);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const handleLogout = () => {
    setUser(null);
    setIsAuthenticated(false);
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    clearMessages(); // Clear chat messages
  };

  const handleSwitchToSignup = () => {
    setShowSignup(true);
  };

  const handleSwitchToLogin = () => {
    setShowSignup(false);
  };

  // Show authentication screens if not logged in
  console.log('App.js render - isAuthenticated:', isAuthenticated, 'showSignup:', showSignup);
  
  if (!isAuthenticated) {
    console.log('App.js render - showing login/signup screen');
    return showSignup ? (
      <Signup onSignup={handleSignup} onSwitchToLogin={handleSwitchToLogin} />
    ) : (
      <Login onLogin={handleLogin} onSwitchToSignup={handleSwitchToSignup} />
    );
  }

  // Show chat interface if authenticated
  return (
    <div className="App">
             {/* Header */}
       <header className="bg-white shadow-sm border-b border-gray-200">
         <div className="max-w-4xl mx-auto px-4 py-4 flex justify-between items-center">
           <div className="flex items-center space-x-3">
             <div className="w-8 h-8 bg-indigo-600 rounded-full flex items-center justify-center">
               <span className="text-white font-bold text-sm">L</span>
             </div>
                                                         <div>
                  <h1 className="text-xl font-semibold text-gray-900">{process.env.REACT_APP_DISPLAY_NAME || 'Chatbot'}</h1>
                                     <div className="text-xs text-gray-400">
                     {VERSION}
                   </div>
                </div>
           </div>
          <div className="flex items-center space-x-4">
            <span className="text-sm text-gray-600">
              Welcome, {user?.username}!
            </span>
            <button
              onClick={loadHistory}
              className="px-3 py-1 text-sm bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors mr-2"
              title="Load previous chat history"
            >
              Reload Old Chat
            </button>
            <button
              onClick={resetChat}
              className="px-3 py-1 text-sm bg-red-500 text-white rounded hover:bg-red-600 transition-colors mr-2"
              title="Reset chat history"
            >
              Reset Chat
            </button>
            <button
              onClick={handleLogout}
              className="text-sm text-gray-500 hover:text-gray-700"
            >
              Logout
            </button>
          </div>
        </div>
      </header>

             {/* Chat Container */}
       <div className="chat-container max-w-4xl mx-auto w-full">
         {/* Messages */}
         <div className="messages-container space-y-4">
                     {messages.length === 0 ? (
                           <div className="text-center text-gray-500 mt-8">
                <p>Start a conversation with {process.env.REACT_APP_DISPLAY_NAME || 'Chatbot'}!</p>
                <p className="text-sm mt-2">Ask me anything or try "/version" to see system info.</p>
              </div>
           ) : (
             messages.map((message, index) => (
               <ChatMessage key={index} message={message} />
             ))
           )}
                                   {isLoading && (
               <div className="flex justify-center">
                 <div className="animate-pulse text-gray-500">{process.env.REACT_APP_DISPLAY_NAME || 'Chatbot'} is thinking...</div>
               </div>
             )}
            {/* Scroll anchor for auto-scroll */}
            <div ref={messagesEndRef} />
         </div>

        {/* Input */}
        <div className="border-t border-gray-200 p-4">
          <ChatInput onSendMessage={sendMessage} disabled={isLoading} />
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gray-50 border-t border-gray-200 py-4">
        <div className="max-w-4xl mx-auto px-4 text-center text-sm text-gray-500">
                          <p>{process.env.REACT_APP_DISPLAY_NAME || 'Chatbot'} - Powered by AWS Bedrock & Claude 3.5 Haiku</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
